export default "__VITE_ASSET__BJuliTe7__"